import { number, string } from "prop-types";

export default {
  id: number.isRequired,
  color: string,
  fname: string,
  lname: string,
  company: string,
  email: string,
  mobile: string,
  phone: string,
  specialisation: string,
  profilePictureUrl: string,
};
